import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Outlet } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AppBar } from '../components/AppBar/AppBar';

export const AppLayout = () => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box display="flex" flexDirection="column" alignItems="stretch" height="100%">
      <AppBar />
      <Box flexGrow={1}>
        <Outlet />
      </Box>
    </Box>
  </LocalizationProvider>
);
